import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from './pages/Home';
import Booking from './pages/Booking';
import Register from './pages/Register';
import Login from './pages/Login';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import updateLocale from 'dayjs/plugin/updateLocale';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { LoadScript } from '@react-google-maps/api'; // ✅ NEW IMPORT

import UserBookings from './pages/UserBookings';
import AddCar from './pages/AddCar';
import AdminHome from './pages/AdminHome';
import EditCar from './pages/EditCar';
import AllBookings from './pages/AllBookings';
import AbandonedSessions from './pages/AbandonedSessions';
import Limo from './pages/limo';
import BlogList from './components/UI/BlogList';
import BlogDetails from './pages/BlogDetails';
import BookingSuccess from './pages/BookingSuccess';

const stripePromise = loadStripe("pk_test_51RK0rn4Nmpmr5A2e2k47JCyFCo6XvP5ACSpAw3vwsWqjY6isWYKv1rufWAbMmdbi5a6EK6yyIFVYtf8HMHEruk7R00qxpt7Uv9");

// Extend dayjs
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

const GOOGLE_API_KEY = 'AIzaSyCgV4mO94GBNyW5qdaK5wX3BuBtz_pHS7s';


function App() {
  return (
    <div className="App">
      <ConfigProvider>
        <LoadScript googleMapsApiKey={GOOGLE_API_KEY} libraries={['places']}> {/* ✅ Wrap here */}
          <BrowserRouter>
            <Routes>
              <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />

              <Route path="/booking/:carid" element={
                <ProtectedRoute>
                  <Elements stripe={stripePromise}>
                    <Booking />
                  </Elements>
                </ProtectedRoute>
              } />

              <Route path="/" element={<Limo />} />

              <Route path="/userbookings" element={<ProtectedRoute><UserBookings /></ProtectedRoute>} />
              <Route path="/addcar" element={<ProtectedRoute><AddCar /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
              <Route path="/editcar/:carid" element={<ProtectedRoute><EditCar /></ProtectedRoute>} />
              <Route path="/admin/bookings" element={<ProtectedRoute><AllBookings /></ProtectedRoute>} />
              <Route path="/admin/abandoned" element={<ProtectedRoute><AbandonedSessions /></ProtectedRoute>} />
              <Route path="/limo" element={<ProtectedRoute><Limo /></ProtectedRoute>} />

              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:id" element={<BlogDetails />} />
              <Route path="/booking-success" element={<BookingSuccess />} />
              
            </Routes>
          </BrowserRouter>
        </LoadScript>
      </ConfigProvider>
    </div>
  );
}

export default App;

export function ProtectedRoute({ children }) {
  const user = localStorage.getItem('user');
  return user ? children : <Navigate to="/login" />;
}
